module.exports = __webpack_public_path__ + "assets/icon-csat-heart-bubble-component.02fd428a.svg";